import { useLanguage } from "../context/LanguageContext";
import { useOrder } from "../hooks/useOrder";
import { OrderStepper } from "../components/order/OrderControls";
import { PackageStep } from "../components/order/PackageStep";
import { ContactStep } from "../components/order/ContactStep";
import { StoryStep } from "../components/order/StoryStep";
import { StyleStep } from "../components/order/StyleStep";
import { LyricsStep } from "../components/order/LyricsStep";
import { PaymentStep } from "../components/order/PaymentStep";
import { RequestSuccess } from "../components/order/RequestSuccess";

const STEPS = [PackageStep, ContactStep, StoryStep, StyleStep, LyricsStep, PaymentStep];

export default function Order() {
  const { t } = useLanguage();
  const order = useOrder();
  let Step = STEPS[order.step];
  if (order.step === 4 && order.isAgreement) Step = RequestSuccess;
  return <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8">
    <p className="eyebrow">{t("Order Flow")}</p>
    <h1 data-testid="order-heading" className="mt-3 font-display text-3xl font-extrabold tracking-tight text-slate-50 sm:text-4xl">{t("Your custom song, step by step")}</h1>
    <p className="mt-3 max-w-2xl text-sm leading-relaxed text-slate-400 sm:text-base">{t("Request → we write the lyric → you confirm → card or Swiss QR payment → production after verified receipt.")}</p>
    <OrderStepper step={order.step} isAgreement={order.isAgreement} />
    <div className="studio-card mt-8 p-6 sm:p-10">
      {order.error && <p role="alert" data-testid="order-action-error" className="mb-5 text-sm text-rose-300">{t(order.error)}</p>}
      <Step order={order} />
    </div>
  </div>;
}